// Data-driven keyboard command registry. Each command is { id, when, run }; on a
// keydown the dispatcher runs the FIRST command whose `when` matches, then stops
// — first-match-wins, exactly like the hand-written if/else chain it replaces.
// Registration order IS priority (register more specific / higher-priority
// commands first). Subsystems register their shortcuts from their own module
// instead of editing one central keydown handler — that handler was a recurring
// merge-conflict hot zone.
//
// A command's `run` is responsible for its own e.preventDefault(): some shortcuts
// suppress the browser default, some intentionally fall through to it (e.g. Cmd+C
// with no selection). A command that matches but does nothing still consumes the
// event (the dispatcher stops) — again matching the original `return` behaviour.

export interface KeyCommand {
  id: string;
  when: (e: KeyboardEvent) => boolean;
  run: (e: KeyboardEvent) => void;
}

export interface Keymap {
  register(cmd: KeyCommand): void;
  dispatch(e: KeyboardEvent): void;
}

export function createKeymap(): Keymap {
  const commands: KeyCommand[] = [];
  return {
    register(cmd): void {
      commands.push(cmd);
    },
    dispatch(e): void {
      for (const c of commands) {
        if (c.when(e)) {
          c.run(e);
          return; // first match wins
        }
      }
    },
  };
}
